import { DirectiveBinding } from 'vue/types/options';

const update = (el: HTMLElement, binding: DirectiveBinding) =>
  (el.style.visibility = binding.value ? '' : 'hidden');

export const hide = {
  bind: update,
  update
};
